import { createContext } from 'react';

const AuthContext = createContext({ loading: true });

export default AuthContext;
